<template>
  <div v-if="amReady">
    <h5 class="pb-2 mb-5 border-bottom text-capitalize" v-if="formHeader">VoIP Trunk</h5>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :translateLabel='false'
            field_mark="required"
            label="name"
            name="name"
            placeholder="Name"
            rules="required"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :options="codecDropDownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Codec"
            name="codec_id"
            placeholder="G729"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark="required"
            label="Trunk IP"
            name="trunk_ip"
            placeholder="123.456.789.0"
            rules="required"></dg-text-field>
      </el-col>

      <el-col v-if="userIsMRT" :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-text-field
            :control="control"
            :disabled="true"
            :editable="editable"
            :defaultValue="$store.state['voip-mrt-enterprise-trunk-api'].fixedPrefix"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark="required"
            label="Fixed Prefix"
            name="fixed_prefix"
            placeholder=""
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :translateLabel='false'
            label="Tech Prefix"
            name="prefix"
            placeholder=""
            ></dg-text-field>
      </el-col>

      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{
              (requestErrorMessage) ? requestErrorMessage : $ml.get('fields_do_not_match_the_required_criteria')
            }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="removeAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                     :translate="false"
                     :type="actionButtonType" fieldSize="mini"
                     v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

    <h5 class="pb-1 mt-5 border-bottom" v-if="trunks.length">Existing Trunk</h5>
    <h6 class="font-italic text-secondary pb-1 mt-5" v-else>No Existing Trunk</h6>
    <el-row v-for="(trunk, trunkIndex) in trunks" :key="trunkIndex">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-text-field
            :control="control"
            :disabled="true"
            :editable="editable"
            :defaultValue="trunk.name"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark=""
            label="Name"
            name="fixed_prefix"
            placeholder=""
            rules="required"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-text-field
            :control="control"
            :disabled="true"
            :editable="editable"
            :defaultValue="trunk.codec"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark=""
            label="Codec"
            name="fixed_prefix"
            placeholder=""
            rules="required"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-text-field
            :control="control"
            :disabled="true"
            :editable="editable"
            :defaultValue="trunk.ip"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark=""
            label="IP"
            name="fixed_prefix"
            placeholder=""
            rules="required"></dg-text-field>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-text-field
            :control="control"
            :disabled="true"
            :editable="editable"
            :defaultValue="trunk.prefix"
            :field_span="23"
            :label_span="23"
            :translateLabel='false'
            field_mark=""
            label="Prefix"
            name=""
            placeholder=""
            rules="required"></dg-text-field>
      </el-col>
      <dg-button type="danger" text="remove" class="p-2 text-capitalize ml-4" style="margin-top: 27px;" @click="removeUserTrunk(trunk.id)">Remove</dg-button>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import module from './../index.js'
import {mapState, mapActions} from 'vuex'
import {notify} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';

export default {
  mixins: [fieldController, moduleForm],
  props: {
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
    moduleDeleteAction: {
      required: false
    }
  },
  data() {
    return {
      userIsMRT: this.$store.getters['user-state/isUserMrt'],
      userIsMRTEnterprise:  this.$store.getters['user-state/isUserMrtEnterprise'],
      trunks: [],
      divisionList: [],
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      codecDropDownList: [],
      requestErrorMessage: null,
      module: {
        ...module
      }
    }
  },
  beforeMount() {
    this.listTrunks({}).then(r => {
      this.trunks = r.rows
    })
    this.getUserFixedPrefix().then( r => {
      this.getDivisionsDropDownList().then(r => {
        this.divisionList = r
      })
      this.getCodecDropdownList().then((r) => {
        this.codecDropDownList = r
        this.amReady = true
        Vue.nextTick(() => {
          this.bindController()
        })
      })
    })
  },
  methods: {
    removeUserTrunk (trunkId, index) {
      this.removeTrunk({id: trunkId}).then( r => {
        this.trunks.splice(index, 1)
        notify({
          type: 'success',
          title: 'Trunk Removed',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      })
    },
    ...mapActions('voip-mrt-enterprise-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...mapActions(module.info.name + '-state', {setModuleState: 'setState'}),
    ...mapActions(module.info.name + '-api', {
      getEntityDropDownList: 'getDropDownList',
      getCodecDropdownList: 'getCodecDropdownList',
      getUserFixedPrefix: 'getUserFixedPrefix',
      listTrunks: 'list',
      removeTrunk: 'remove'
    }),
    removeAction() {
      this.moduleDeleteAction()
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'create';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          Vue.nextTick(() => {
            this.listTrunks({}).then(r => {
              this.trunks = r.rows
              context.amReady = true
            })
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          if (error.response.data.errorMessage) {
            this.validData = false
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
